function getCoordinates() {
    return new Promise(function(resolve, reject) {
        return navigator.geolocation.getCurrentPosition(resolve, reject);
    });
}

async function getLatLon() {
    try{
        let position = await getCoordinates();
        return { lat : position.coords.latitude, lon : position.coords.longitude };
    }
    catch(err) {
        return { errorMsg : err.message};
    }
}

export default {getLatLon}